// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"
// TODO Remove the following (need to remove the initializer and js file as well)
import Pagy from "./src/pagy/pagy.mjs";
import LocalTime from "local-time"
LocalTime.start()

Turbo.StreamActions.redirect = function () {
  Turbo.visit(this.target);
};

// Initialize Pagy
window.addEventListener("turbo:load", Pagy.init)